import { StepConfig, StepsDataState } from "../hearing-aids-wizard.type";

export const getInitialStepsData = (
  stepsConfig: StepConfig[],
  stepsData: StepsDataState = {}
) => {
  const result: StepsDataState = {};

  stepsConfig.forEach((step) => {
    if (step.substeps.length) {
      step.substeps.forEach((subStepId) => {
        result[subStepId] = stepsData[subStepId] ?? {};
      });
    } else {
      result[step.id] = stepsData[step.id] ?? {};
    }
  });

  return result;
};
